import { render, staticRenderFns } from "./organizationStatus.vue?vue&type=template&id=45d86f9b&"
import script from "./organizationStatus.vue?vue&type=script&lang=js&"
export * from "./organizationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports